const InternalTexts = () => import('@pages/internal/texts.vue');
const InternalPoppers = () => import('@pages/internal/poppers.vue');
const InternalModals = () => import('@pages/internal/modals.vue');
const InternalIcons = () => import('@pages/internal/icons.vue');
const InternalTiles = () => import('@pages/internal/tiles.vue');
export const internalRoutes = [
  { path: 'tiles', component: InternalTiles, meta: { title: 'Tiles' } },
  { path: 'texts', component: InternalTexts, meta: { title: 'Texts' } },
  { path: 'poppers', component: InternalPoppers, meta: { title: 'Poppers' } },
  { path: 'modals', component: InternalModals, meta: { title: 'Modals' } },
  {
    path: 'icons',
    component: InternalIcons,
    meta: { title: 'Icons' },
  },
].map((route) => ({ ...route, name: `internal-${route.path}` }));
